import { Environment } from 'react-relay';

import { fireLoginHandlers } from '../../utils/loginHandlers';
import { trackRegistrationComplete } from './authTracking';
import { setTokens, updateProfile } from './userStorageActions';

import { AuthResponseType } from './authTypes';

export const authTrackingHandler = ({
    userRegistration,
    ga,
    environment,
}: {
    userRegistration: AuthResponseType;
    ga: Record<string, string>;
    environment: Environment;
}): void => {
    trackRegistrationComplete({ ...userRegistration, ...ga });

    setTokens({
        ...userRegistration,
        environment,
    });

    updateProfile({ ...userRegistration, environment }).then(() => {
        fireLoginHandlers(userRegistration);
    });
};
